import { render } from "./audio-views.vue?vue&type=template&id=510a05ae"
import script from "./audio-views.vue?vue&type=script&lang=js"
export * from "./audio-views.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__